// extracted by mini-css-extract-plugin
export default {"box":"cancellationFilterPage_box__6qJyr","box__content":"cancellationFilterPage_box__content__JjG8l"};